module.exports = __webpack_public_path__ + "static/media/kova_apple.690e3e0a.jpg";